import { gql } from '@apollo/client';
import React from 'react';
import Avatar from '../components/Avatar';
import type { MagneticWallItemAvatar_UserFragment } from '../graphql/generated/graphqlTypes';

const USER_FRAGMENT = gql`
  fragment MagneticWallItemAvatar_user on PublicUserFields {
    ...Avatar_user
  }
  ${Avatar.fragments.user}
`;

interface MagneticWallItemAvatarProps {
  user: MagneticWallItemAvatar_UserFragment;
}

const MagneticWallItemAvatar = ({ user }: MagneticWallItemAvatarProps) => {
  return <Avatar size={28} user={user} />;
};

MagneticWallItemAvatar.fragments = { user: USER_FRAGMENT };

export default MagneticWallItemAvatar;
